// utils/cache.js
import { ref } from 'vue';

export const cacheKeyList = ref([]);

// 添加缓存
export function addCache(key) {
    if (!cacheKeyList.value.includes(key)) {
        cacheKeyList.value.push(key);
    }
}

// 移除缓存
export function removeCache(key) {
    const index = cacheKeyList.value.indexOf(key);
    if (index !== -1) {
        cacheKeyList.value.splice(index, 1);
    }
}
